import { atom } from 'recoil';
import { BuildingType, FloorPlanType } from '../../contexts/AggregatesContext/types';
import { loadPersistedValue, persistOnSet } from '../effects';

export const selectedFloorPlanState = atom<FloorPlanType | null>({
  key: 'selectedFloorPlanState',
  default: null,
  effects: [persistOnSet, loadPersistedValue],
});

export const floorPlansState = atom<FloorPlanType[]>({
  key: 'floorPlansState',
  default: [],
});

export const buildingsState = atom<BuildingType[]>({
  key: 'buildingsState',
  default: [],
});
